module.exports = __webpack_public_path__ + "img/c_photo_3.4ad0c661.png";